export const GUEST_TOKEN_EXPIRY_SECONDS = 1 * 60 * 60;
export const VERIFIED_TOKEN_EXPIRY_SECONDS = 24 * 60 * 60;

export function calculateTokenExpiry(
  expiresInSeconds: number | undefined,
  defaultExpirySeconds: number
): number {
  const expiresInMs = (expiresInSeconds || defaultExpirySeconds) * 1000;
  return Date.now() + expiresInMs;
}

export function storeTokenWithExpiry(
  token: string,
  expiresInSeconds: number | undefined,
  defaultExpirySeconds: number,
  tokenKey: string,
  expiryKey: string
): void {
  const expiryTime = calculateTokenExpiry(
    expiresInSeconds,
    defaultExpirySeconds
  );
  sessionStorage.setItem(tokenKey, token);
  sessionStorage.setItem(expiryKey, expiryTime.toString());
}
